export const BRAND = {
  name: "alfabrains",
  tagline: "Online Tutoring",
  logo: "/logo.png",
  whatsapp: "919355528522",
  phone: "+91 9355528522",
  email: "info@alfabrains.com",
  social: {
    facebook: "https://www.facebook.com/alfabrains",
    instagram: "https://www.instagram.com/alfabrains",
    youtube: "https://www.youtube.com/@alfabrains",
    whatsapp: "https://wa.me/919355528522",
  },
};

export const SUBJECTS = [
  "Mathematics", "Science", "English", "Social Studies", "Hindi",
  "Sanskrit", "Computer", "EVS", "Spoken English", "Vedic Maths", "Abacus", "Olympiad",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1623076189461-f7706b741c04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxvbmxpbmUlMjB0dXRvcmluZyUyMGVkdWNhdGlvbiUyMGNoaWxkJTIwbGFwdG9wfGVufDB8fHx8MTc4NjQyODIzNnww&ixlib=rb-4.1.0&q=85",
  parent: "https://images.unsplash.com/photo-1783873231697-3909aeda2381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBjaGlsZCUyMHN0dWR5aW5nJTIwb25saW5lJTIwYXQlMjBob21lfGVufDB8fHx8MTc4NjQyODIzNnww&ixlib=rb-4.1.0&q=85",
  boy: "https://images.unsplash.com/photo-1755534316951-8a2c8ad3b56f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjaGlsZCUyMHN0dWR5aW5nJTIwb25saW5lJTIwYXQlMjBob21lfGVufDB8fHx8MTc4NjQyODIzNnww&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) lenis.scrollTo(id, { offset: -80, duration: 1.2 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
};
